import { createGlobalState } from 'react-use'

interface FormStoreProps {
  isMulticardFlow: boolean
}

export default createGlobalState<FormStoreProps>({
  isMulticardFlow: false,
})
